/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-10 11:53:30
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-06-23 17:59:04
 * @name: 默认配置
 * @Description: 默认配置
 * @FilePath: \project\src\nestVue\config\default.config.js
 * @Author: desktop
 */
import { Message } from 'element-ui';
import userStorage from '@/storage/user.storage'; //用户存储

const defaultConfig = {
  // 前置拦截器
  before: (instance) => {
    instance.interceptors.request.use(config => {
      const token = new userStorage().token;
      token && (config.headers.Authorization = token);
      config.timeout = 8000;
      return config;
    })
  },
  // 后置拦截器
  after: (instance) => {
    instance.interceptors.response.use(response => {
      let res = { code: response.data.code, msg: response.data.msg, data: response.data.data };
      if (res.code === 200) {
        return res;
      } else if (res.code === 401) {
        new userStorage().removeToken();
        location.reload();
      } else {
        return Promise.reject(res);
      }
    }, error => {
      error = JSON.parse(JSON.stringify(error));
      if (error?.response) {
        console.error(error);
      } else {
        Message.error(error.message);
      }
      return Promise.reject(error);
    })
  },
  toastSuccess: false,
  successMsg: '',
  showLoading: false,
}
export default defaultConfig;